// Targets must already reach the ASP.NET backend on S144 (nginx allowlist).
// Unknown /api/Home/* names (LoginOAuthUser, UnionBerlinLogin, *OAuthCallback) are served as SPA.
const ssoCallbackRoutes = [
  { path: '/sso', targetPath: '/api/Home/EvonikLogin' },
  { path: '/googlesso', targetPath: '/api/Home/GoogleLogin' },
  { path: '/unionsso', targetPath: '/api/Home/LoginEvonikOAuthUser' },
  { path: '/fcspsso', targetPath: '/api/Home/FcspLogin' },
  { path: '/clientsso', targetPath: '/api/Home/OauthLogin' },
];

export default ssoCallbackRoutes;
